export const priceHikeMap = new Map<string, number>([
  ['reg-monthly-aud', 16.99],
  ['reg-monthly-cad', 16.99],
  ['reg-monthly-egp', 6.99],
  ['reg-monthly-eur', 16.99],
  ['reg-monthly-gbp', 14.99],
  ['reg-monthly-inr', 599],
  ['reg-monthly-mxn', 16.99],
  ['reg-monthly-pln', 16.99],
  ['reg-monthly-sar', 16.99],
  ['reg-monthly-usd', 16.99],
  ['reg-monthly-usd-tier-1', 6.99],
  ['reg-monthly-usd-tier-2', 11.99],
]);
